import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SignUpDto } from "../../lib/api-client-generated-types";

interface RegisterFormState {
  step: 1 | 2;
  formData: Partial<SignUpDto>;
  levelGroupId?: number;
}

const initialState: RegisterFormState = {
  step: 1,
  formData: {
    termsAccepted: false,
    hasScholarship: false,
  },
  levelGroupId: undefined,
};

export const registerFormSlice = createSlice({
  name: "registerForm",
  initialState,
  reducers: {
    setStep: (state, action: PayloadAction<1 | 2>) => {
      state.step = action.payload;
    },
    setFormData: (state, action: PayloadAction<Partial<SignUpDto>>) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    setLevelGroupId: (state, action: PayloadAction<number | undefined>) => {
      state.levelGroupId = action.payload;
    },
    resetForm: (state) => {
      state.step = initialState.step;
      state.formData = initialState.formData;
      state.levelGroupId = initialState.levelGroupId;
    },
  },
});

export const { setStep, setFormData, setLevelGroupId, resetForm } = registerFormSlice.actions; 